module.exports = __webpack_public_path__ + "static/media/close-circle.7658e946.svg";